import React from 'react'

const ServiceTitle = ({ record }) => {
  return <span>Service {record ? `"${record.label}"` : ''}</span>
}

export default ServiceTitle



// WEBPACK FOOTER //
// ./src/components/ServiceTitle.js